<template>
<div class="inline-form">
	<v-select
	                                    v-model="filters.m_l"
	                                    :items="m_lOpts"
	                                    :menu-props="{ maxHeight: '400' }"
	                                    label="M/L/Unisex"                                    
	                                    persistent-hint
	                                    multiple
	                                    @change="m_lFilter"

	                                  ></v-select>
	                                <v-select
	                                    v-model="filters.colour"
	                                    :items="colours"
	                                    :menu-props="{ maxHeight: '400' }"
	                                    label="Colour"                                    
	                                    persistent-hint
	                                    multiple
	                                    @change="colourFilter"
	                                  ></v-select>
	                                  <v-select
	                                    v-model="filters.size"
	                                    :items="sizes"
	                                    :menu-props="{ maxHeight: '400' }"
	                                    label="Size"                                    
	                                    persistent-hint
	                                    multiple
	                                    @change="sizeFilter"
	                                  ></v-select>
                                      <v-btn text @click="clearFilter()">Clear</v-btn>
</div>
</template>

<script>
	import { mapState } from 'vuex'
export default {

	data: () => ({

      filters : {
                    m_l : [],
                    colour : [],
                    size : []
                },
   
     
    }),

    mounted () {
            if (this.$store.state.merch.lenght == 0)
            this.$store.dispatch('fetchMerch')
        },

    computed : {
    	...mapState(['m_lOpts']),
        ...mapState(['colours']),
        ...mapState(['sizes']),

    
    },

    watch : {

    	
    },

    methods : {

    	m_lFilter(val) {

    		this.filters.m_l = val
    		this.$store.commit('SET_MERCHFILTERS', this.filters)
    	},

    	colourFilter(val) {

    		this.filters.colour = val
    		this.$store.commit('SET_MERCHFILTERS', this.filters)
    	},

    	sizeFilter(val) {

    		this.filters.size = val
    		this.$store.commit('SET_MERCHFILTERS', this.filters)
    	},

        clearFilter(){

            this.filters.size = this.filters.colour = this.filters.m_l = []
            

            this.$store.commit('SET_MERCHFILTERS', this.filters)

        }

    }


    

}
</script>

<style>

</style>